module.exports = __webpack_public_path__ + "static/sceneseer.7fe00f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sceneseer.png
// module id = 703
// module chunks = 19843951674672